import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  CloseStyleSwitcherEvent,
  OpenStyleSwitcherEvent,
  SelectStyleSwitcherEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const OPEN_STYLE_SWITCHER_EVENT = 'open_style_switcher'

export const triggerOpenStyleSwitcherEvent = (event: OpenStyleSwitcherEvent) =>
  triggerEvent(OPEN_STYLE_SWITCHER_EVENT, event)

export const onOpenStyleSwitcherEvent = (
  callback: EventCallback<OpenStyleSwitcherEvent>
) => subscribeEvent(OPEN_STYLE_SWITCHER_EVENT, callback)

export const removeOpenStyleSwitcherEvent = (
  token: EventToken<OpenStyleSwitcherEvent>
) => unsubscribeEvent(OPEN_STYLE_SWITCHER_EVENT, token)

const CLOSE_STYLE_SWITCHER_EVENT = 'close_style_switcher'

export const triggerCloseStyleSwitcherEvent = (
  event: CloseStyleSwitcherEvent
) => {
  triggerEvent(CLOSE_STYLE_SWITCHER_EVENT, event)
}

export const onCloseStyleSwitcherEvent = (
  callback: EventCallback<CloseStyleSwitcherEvent>
) => subscribeEvent(CLOSE_STYLE_SWITCHER_EVENT, callback)

export const removeCloseStyleSwitcherEvent = (
  token: EventToken<CloseStyleSwitcherEvent>
) => unsubscribeEvent(CLOSE_STYLE_SWITCHER_EVENT, token)

const SELECT_STYLE_SWITCHER_EVENT = 'select_style_switcher'

export const triggerSelectStyleSwitcherEvent = (
  event: SelectStyleSwitcherEvent
) => {
  triggerEvent(SELECT_STYLE_SWITCHER_EVENT, event)
}

export const onSelectStyleSwitcherEvent = (
  callback: EventCallback<SelectStyleSwitcherEvent>
) => subscribeEvent(SELECT_STYLE_SWITCHER_EVENT, callback)

export const removeSelectStyleSwitcherEvent = (
  token: EventToken<SelectStyleSwitcherEvent>
) => unsubscribeEvent(SELECT_STYLE_SWITCHER_EVENT, token)
